import { render, staticRenderFns } from "./gift_record.vue?vue&type=template&id=9bf6b0f2&scoped=true"
import script from "./gift_record.vue?vue&type=script&lang=ts"
export * from "./gift_record.vue?vue&type=script&lang=ts"
import style0 from "./gift_record.vue?vue&type=style&index=0&id=9bf6b0f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bf6b0f2",
  null
  
)

export default component.exports